/**
 * @file dashboardPatientView.jsx
 * @author Fernando Ruano
 * @description Patient Dashboard View
 */

// Dependencies
import { Row } from 'antd';
import {
  ExperimentFilled,
  FormOutlined,
  MedicineBoxFilled,
  PushpinFilled,
  ScheduleFilled
} from '@ant-design/icons';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Cards
import ContactFloatingButton from 'pages/ContactFloatingButton';
import BloodGlucoseCard from './components/bloodGlucoseCard';
import AdherenceCard from './components/adherenceCard';
import BloodPressureCard from './components/bloodPressureCard';
import NutritionalCard from './components/nutritionalCard';
import KidneyProgressCard from './components/kidneyProgressCard';
import MyStageCard from './components/myStageCard';
import DashboardLinkButton from './components/dashboardLinkButton';

const DashboardPatientView = () => {
  const style = { fontSize: 25, color: 'white' };
  return (
    <AppCardLayout>
      <div className="h-full flex flex-col">
        <div className="p-4">
          <Row gutter={[14, 14]} className="pb-4">
            <MyStageCard />
            <KidneyProgressCard />
            <BloodPressureCard />
            <BloodGlucoseCard />
            <NutritionalCard />
            <AdherenceCard />

            <div className="w-full flex flex-wrap gap-y-4">
              <DashboardLinkButton
                title="Mis laboratorios"
                icon={<ExperimentFilled style={style} />}
                link="/main/exams"
              />
              <DashboardLinkButton
                title="Mis citas"
                icon={<ScheduleFilled style={style} />}
                link="/main/appointments"
              />
              <DashboardLinkButton
                title="Mis registros"
                icon={<FormOutlined style={style} />}
                link="/main/patient-blood-presure"
              />
              <DashboardLinkButton
                title="Mis eventos"
                icon={<MedicineBoxFilled style={style} />}
                link="/main/events"
              />
              <DashboardLinkButton
                title="Mis recomendaciones"
                icon={<PushpinFilled style={style} />}
                link="/main/patient-my-recomendations"
              />
            </div>
          </Row>
        </div>
        <ContactFloatingButton />
      </div>
    </AppCardLayout>
  );
};

/**
 * Component definition of proptypes.
 */

export default DashboardPatientView;
